(() => {
  const handles = {
      "bambu-lab-h2c-laser-full-combo-3d-printer": "h2c",
      "bambu-lab-h2c-ams-combo-3d-printer": "h2c",
      "bambu-lab-h2s-ams-combo-3d-printer": "h2s",
      "bambu-lab-a2l-ams-combo-3d-printer": "a2l",
      "bambu-lab-p1s-combo-multi-material-multi-color-3d-printer": "p1s",
      "bambu-lab-p1s-multi-material-multi-color-3d-printer": "p1s",
      "bambu-lab-x2d-ams-combo-3d-printer": "x2d",
      "bambu-lab-x2d-3d-printer": "x2d",
      "bambu-lab-p2s-3d-printer": "p2s",
      "bambu-lab-a2l-3d-printer": "a2l",
      "bambu-lab-a1-combo-3d-printer": "a1",
      "bambu-lab-a1-3d-printer": "a1",
      "bambu-lab-h2d-pro-3d-printer": "h2d",
      "bambu-lab-h2d-laser-full-combo-3d-printer": "h2dLaser",
    },
    families = {
      h2d: {
        source: "https://eu.store.bambulab.com/products/h2d",
        sections: [
          [
            "Dual-nozzle multi-material printing",
            "Dedicated nozzles combine rigid, flexible, support and engineering materials while reducing purging and material changeover.",
            "https://store.bblcdn.com/4731f4c55a/bd41b5bfcbfd427aa1c3db5ba6e3294e/FeatureBlock_1_src.jpg",
          ],
          [
            "Dedicated support material",
            "Use a separate support interface material for cleaner surfaces, easier removal and substantially less waste.",
            "https://store.bblcdn.com/4731f4c55a/cd8069f3c58f433694e7eae305763ad8/FeatureBlock_2_src.jpg",
          ],
          [
            "Large, precise workspace",
            "A build volume up to 350 × 320 × 325 mm and optical motion calibration support ambitious parts with repeatable dimensional accuracy.",
            "https://store.bblcdn.com/4731f4c55a/244cf93a123e4a76877f6d19548128eb/King_Size_Image_2_pcSrc.jpg",
          ],
          [
            "350°C hotend and active chamber heating",
            "Controlled high-temperature printing improves layer bonding and dimensional stability with demanding engineering polymers.",
            "https://store.bblcdn.com/4731f4c55a/549efa60c99d430289ca5e08bebfd07c/Chamber_Heating_1_pcSrc.jpg",
          ],
          [
            "AI-assisted nozzle monitoring",
            "A macro nozzle camera monitors extrusion behaviour and helps detect material accumulation, deviations and extrusion failures.",
            "https://store.bblcdn.com/4731f4c55a/a9d43c1c4c6f42d8a2cfe3a28df1fc3f/Nozzle_Camera_1_pcSrc.jpg",
          ],
        ],
      },
      h2dLaser: {
        source: "https://eu.store.bambulab.com/products/h2d",
        sections: [
          [
            "Dual-nozzle personal manufacturing",
            "Combine multi-material 3D printing with laser engraving, cutting and pen drawing in one coordinated platform.",
            "https://store.bblcdn.com/4731f4c55a/d899fdef101546398aaa6bf889c93ffa/FeatureBlock_3_src.jpg",
          ],
          [
            "Integrated laser protection",
            "Purpose-designed safety windows make it possible to monitor laser work while maintaining a controlled operating environment.",
            "https://store.bblcdn.com/4731f4c55a/4686ccb20f8a4077bfccb342ac18ce62/Laser_Protective_pcSrc.jpg",
          ],
          [
            "Automatic laser calibration",
            "One guided workflow verifies focus and measures the material, reducing manual setup before engraving or cutting.",
            "https://store.bblcdn.com/4731f4c55a/e66adb0c07084260a0abdc6430090265/Full_Auto_pcSrc.jpg",
          ],
          [
            "Air assist",
            "High-speed directed air cools the laser path to produce cleaner cuts and more consistent engraved surfaces.",
            "https://store.bblcdn.com/4731f4c55a/9c58b60ebec54a4bba4f3cb7173fbe09/Air_Assist_pcSrc.jpg",
          ],
          [
            "Contactless 3D mesh",
            "Optical height measurement maps curved objects without contact, enabling accurately positioned laser work on non-flat surfaces.",
            "https://store.bblcdn.com/4731f4c55a/3814c69778ae4f22b9584eedf19089eb/Contact_Less_pcSrc.jpg",
          ],
        ],
      },
      h2c: {
        source: "https://jp.store.bambulab.com/products/h2c",
        sections: [
          [
            "Vortek multi-hotend system",
            "Produce multi-colour and multi-material parts with dedicated hotends, reducing purge waste while keeping material changes organised.",
            "https://store.bblcdn.eu/s8/default/c78ac4d1b21a45e3b8970e956d2e88f1/H2C_vortek_bundle.jpg",
          ],
          [
            "Designed for complex material workflows",
            "Combine structural, flexible and support materials in one coordinated workflow, with automatic hotend identification and repeatable setup.",
            "https://store.bblcdn.eu/s8/default/a0539597942f4de8b89fd9e37892b72b/bambu-lab-pla-pure-1-kg-with-spool-baby-blue-17600.jpg",
          ],
          [
            "A complete personal manufacturing platform",
            "The H2C platform combines precise 3D printing with secure connectivity and, on Laser Full Combo versions, laser and digital cutting capabilities.",
            "https://store.bblcdn.eu/s8/default/0b42574d87e74d87a92a8ef7339b9429/7.jpg",
          ],
        ],
      },
      h2s: {
        source: "https://us.store.bambulab.com/products/h2s",
        sections: [
          [
            "Large-format production",
            "A 340 \xD7 320 \xD7 340 mm build volume gives prototypes, fixtures and end-use parts more room while preserving the speed of the H2 platform.",
            "https://store.bblcdn.eu/s8/default/5e918f0df4214a47b0263d36b5955c0f/bambu-lab-h2s-3d-printer-official-bambu-lab-image-2.jpg",
          ],
          [
            "Controlled engineering-material printing",
            "A 350\xB0C nozzle and actively heated chamber support demanding polymers with improved thermal consistency and reduced warping.",
            "https://store.bblcdn.eu/s8/default/6a275d7399a1470db3de032df0af7023/bambu-lab-h2s-3d-printer-official-bambu-lab-image-3.jpg",
          ],
          [
            "Automated monitoring and calibration",
            "An integrated sensor and camera system assists motion calibration, extrusion control and print monitoring for repeatable operation.",
            "https://store.bblcdn.eu/s8/default/ecc8ff7cdc024e3cabefdafd0d835660/bambu-lab-h2s-3d-printer-official-bambu-lab-image-4.jpg",
          ],
        ],
      },
      a2l: {
        source:
          "https://blog.bambulab.com/bambu-lab-a2l-creative-playground-extra-large/",
        immersive: true,
        eyebrow: "Bambu Lab A2L",
        headline: "Creative Playground. Extra Large.",
        intro:
          "A large-format creative platform built to produce ambitious projects in one piece, with the accessibility and automation of the A Series.",
        hero:
          "https://storage.ghost.io/c/8d/d9/8dd9f85b-21c3-4782-bba8-8778cd8f2f93/content/images/size/w1200/2026/05/BBL-A2L-00-hero.jpg",
        heroVideo:
          "https://portal.bblmw.com/a2l/vekn9whmb5k/highlight/PC.mp4",
        stats: [
          ["330 × 320 × 325 mm", "Build volume"],
          ["105% more space", "Than 256 mm-class printers"],
          ["Below 49 dB", "Silent mode"],
        ],
        sections: [
          [
            "A bigger stage for bigger ideas",
            "With a 330 × 320 × 325 mm build volume, the A2L offers 105% more creative space than standard 256 mm-class machines—enough for larger props, home décor and production batches without splitting every model.",
            "https://portal.bblmw.com/a2l/hl38wbwrmum/2/video/PC.mp4",
            "panorama",
            "https://portal.bblmw.com/a2l/hl38wbwrmum/2/video/PC.jpg?x-oss-process=image%2Fformat%2Cwebp",
          ],
          [
            "Adaptive stability at large scale",
            "Multi-point adaptive vibration compensation responds to changing bed loads and toolhead positions. Two granular dampers also absorb physical resonance to preserve clean surfaces on tall and heavy prints.",
            "https://portal.bblmw.com/a2l/hl38wbwrmum/4/adaptive-vibration-compensation/PC-EN/video.mp4",
            "split",
            "https://portal.bblmw.com/a2l/hl38wbwrmum/4/adaptive-vibration-compensation/PC-EN/cover.jpg?x-oss-process=image%2Fformat%2Cwebp",
          ],
          [
            "Closed-loop PMSM extrusion",
            "The servo-driven extrusion system delivers stable power during high-speed printing while actively monitoring material flow and detecting extrusion anomalies before they become failed parts.",
            "https://storage.ghost.io/c/8d/d9/8dd9f85b-21c3-4782-bba8-8778cd8f2f93/content/images/2026/05/BBL-A2L-04.jpg",
            "spotlight",
          ],
          [
            "Modularity that changes the rules",
            "A dedicated expansion point supports blade cutting and pen plotting. With camera-assisted alignment and Print-then-Cut workflows, the A2L extends beyond 3D printing into a broader creative workshop.",
            "https://portal.bblmw.com/a2l/hl38wbwrmum/3/pen-drawing/PC.mp4",
            "split",
            "https://portal.bblmw.com/a2l/hl38wbwrmum/3/pen-drawing/PC-cover.jpg?x-oss-process=image%2Fformat%2Cwebp",
          ],
          [
            "Intelligent protection, always watching",
            "Physical nozzle protection and extrusion monitoring identify abnormal filament buildup before it becomes a failed print, complementing runout, clog and tangled-spool detection.",
            "https://portal.bblmw.com/a2l/hl38wbwrmum/6/nozzle-clumping-detector/PC.mp4",
            "panorama",
            "https://portal.bblmw.com/a2l/hl38wbwrmum/6/nozzle-clumping-detector/pc-cover.jpg?x-oss-process=image%2Fformat%2Cwebp",
          ],
        ],
      },
      p1s: {
        source: "https://us.store.bambulab.com/products/p1s",
        sections: [
          [
            "Ready to print out of the box",
            "Automatic bed levelling and vibration compensation simplify setup, helping users move quickly from a model to a reliable finished part.",
            "https://store.bblcdn.eu/s8/default/da1505746a2e426685f965b1386103fd/Frame_1123862848-tuya.jpg",
          ],
          [
            "Enclosed for broader material use",
            "The enclosed body, chamber regulation and activated-carbon filtration make the P1S a versatile platform for everyday and higher-temperature filaments.",
            "https://store.bblcdn.eu/s8/default/1faa47f8c570409fb82fcb145c2a11e2/bambu-lab-h2d-pro-printer-dark-background.jpg",
          ],
          [
            "Fast, precise and AMS-ready",
            "High acceleration, pressure advance and vibration compensation support fast production, while AMS compatibility enables multi-colour workflows.",
            "https://store.bblcdn.eu/s8/default/5a3cc917b98c46f3a4802fa65e24de40/bambu-lab-pla-pure-1-kg-with-spool-apricot-17300.jpg",
          ],
        ],
      },
      x2d: {
        source:
          "https://blog.bambulab.com/xcellence-made-simple-bambu-lab-presents-the-x2d/",
        sections: [
          [
            "Independent dual-nozzle printing",
            "Use dedicated nozzles for two colours, support interfaces or complementary materials while reducing unnecessary purging and changeover time.",
            "https://storage.ghost.io/c/8d/d9/8dd9f85b-21c3-4782-bba8-8778cd8f2f93/content/images/size/w1600/2026/04/X2D-105jpg.jpg",
          ],
          [
            "Professional thermal control",
            "The enclosed platform is designed for stable production with engineering materials and demanding multi-material combinations.",
            "https://storage.ghost.io/c/8d/d9/8dd9f85b-21c3-4782-bba8-8778cd8f2f93/content/images/size/w1600/2026/04/X2D-104.jpg",
          ],
          [
            "Automation throughout the workflow",
            "Integrated calibration, monitoring and material-management tools help make complex prints more repeatable from preparation to completion.",
            "https://storage.ghost.io/c/8d/d9/8dd9f85b-21c3-4782-bba8-8778cd8f2f93/content/images/size/w1600/2026/04/X2D-108.jpg",
          ],
        ],
      },
      p2s: {
        source: "https://us.store.bambulab.com/products/p2s",
        sections: [
          [
            "A refined enclosed workhorse",
            "The P2S combines a compact enclosed format with an updated motion and extrusion platform for dependable daily production.",
            "https://store.bblcdn.eu/s8/default/50759f43fac940b8b6b623f726d13a14/bambu-lab-p2s-combo-3d-printer-official-bambu-lab-image-2.jpg",
          ],
          [
            "Consistent high-speed printing",
            "Automatic calibration and controlled extrusion help preserve surface quality and dimensional consistency at productive print speeds.",
            "https://store.bblcdn.eu/s8/default/68d8ba9eb5d640109110017952f7e60e/bambu-lab-pla-pure-1-kg-with-spool-baby-blue-17600.jpg",
          ],
          [
            "Connected multi-colour workflow",
            "AMS compatibility extends the printer to multi-colour and managed-filament production while retaining a straightforward operating experience.",
            "https://store.bblcdn.eu/s8/default/e357a3e8749349608871a890e7bc218b/bambu-lab-pla-pure-1-kg-with-spool-apricot-17300.jpg",
          ],
        ],
      },
      a1: {
        source: "https://us.store.bambulab.com/products/a1",
        sections: [
          [
            "Full-auto calibration",
            "The A1 handles Z offset, bed levelling, vibration resonance and nozzle-pressure calibration automatically for every print job.",
            "https://store.bblcdn.com/8437444c13c842f0b6d56f9e9676547e.mp4",
            "panorama",
            "https://store.bblcdn.com/a2524f0090794d77ab7ece15b1fc9301.webp",
          ],
          [
            "AMS multi-colour printing",
            "AMS lite provides reliable automatic filament selection and RFID synchronisation for multi-colour printing without manual filament-profile setup.",
            "https://store.bblcdn.com/daee45d440704568912668d656d9f169.mp4",
            "split",
            "https://store.bblcdn.com/8ee2ad16731a4e7e80216db5acfbb5b6.webp",
          ],
          [
            "High-speed precision",
            "Low-drag linear rails, accelerometers, nozzle-pressure sensing and advanced motion control deliver stable, repeatable output at speed.",
            "https://store.bblcdn.com/c77b8e3b71344fb982047f3b862fa748.mp4",
            "panorama",
            "https://store.bblcdn.com/2b457df1a555433aad09be9f7236ca8d.webp",
          ],
          [
            "Intelligent print monitoring",
            "A comprehensive monitoring system keeps track of print status and helps identify common problems before they compromise the job.",
            "https://store.bblcdn.com/170c45536a6c4420b2893992634ec878.webp",
            "spotlight",
          ],
          [
            "Full-size build volume",
            "The 256 × 256 × 256 mm workspace provides enough room for functional prototypes, educational projects and large creative parts in a single print.",
            "https://store.bblcdn.com/0136ac152672427e8eafa7c79cea2256.webp",
            "split",
          ],
          [
            "Active motor noise cancelling",
            "The A1 calibrates itself to compensate for the small differences between individual drive motors, reducing harsh motor noise during operation.",
            "https://store.bblcdn.com/s7/default/78eb23a0dcb5431f9e52ce4774cf5860/1ff169376035474c810f74c9ae269729.webp",
            "panorama",
          ],
        ],
      },
    },
    icons = [
      '<svg viewBox="0 0 24 24"><path d="M4 7l8-4 8 4-8 4-8-4Z"/><path d="M4 7v10l8 4 8-4V7M12 11v10"/></svg>',
      '<svg viewBox="0 0 24 24"><path d="M4 14a8 8 0 1 1 16 0"/><path d="m12 14 4-5M6 18h12"/></svg>',
      '<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="8"/><circle cx="12" cy="12" r="3"/><path d="M20 12h2M4 12H2"/></svg>',
    ],
    clean = (value) => (value || "").replace(/\s+/g, " ").trim(),
    short = (value, max = 150) =>
      clean(value)
        .slice(0, max)
        .replace(/[,;:\s]+$/, ""),
    rowData = (table) =>
      [...table.querySelectorAll("tr")]
        .map((row) => {
          const cells = row.querySelectorAll("td,th");
          return {
            row,
            label: clean(cells[0]?.textContent),
            value: clean(cells[1]?.textContent),
          };
        })
        .filter((item) => item.label && item.value),
    findValue = (rows, pattern, fallback) =>
      short(rows.find((item) => pattern.test(item.label))?.value || fallback),
    buildFeatures = (rows) => {
      const values = [
          findValue(
            rows,
            /(?:print|body|build).*volume|volume.*(?:print|build)|حجم (?:الطباعة|البناء)/i,
            m3dProductLabel("see_specs"),
          ),
          findValue(
            rows,
            /printing speed|max speed|speed of toolhead|سرعة (?:الطباعة|رأس الطباعة)/i,
            m3dProductLabel("fast_print"),
          ),
          findValue(
            rows,
            /supported filament|filaments?$|خيوط الطباعة|المواد المتوافقة/i,
            m3dProductLabel("compatible_materials"),
          ),
        ],
        labels = [m3dProductLabel("volume"), m3dProductLabel("speed"), m3dProductLabel("filaments")],
        section = document.createElement("section");
      return (
        (section.className = "m3d-key-specs m3d-template-key-specs"),
        section.setAttribute("aria-label", m3dProductLabel("key_specs")),
        values.forEach((value, index) => {
          const card = document.createElement("div");
          ((card.className = "m3d-key-spec"),
            (card.innerHTML = `<span class="m3d-key-spec-icon">${icons[index]}</span><span class="m3d-key-spec-copy"><span class="m3d-key-spec-label">${labels[index]}</span><span class="m3d-key-spec-value"></span></span>`),
            (card.querySelector(".m3d-key-spec-value").textContent = value),
            section.append(card));
        }),
        section
      );
    },
    addIncludedAms = (media, handle) => {
      if (
        !(handle.startsWith("bambu-lab-") && (handle.includes("combo") || handle === "bambu-lab-h2d-pro-3d-printer") && handle.endsWith("3d-printer"))
      )
        return;
      const scriptSource = [...document.scripts]
          .map((script) => script.src)
          .find((src) => src.includes("m3d-bambu-printer-template.js")),
        isP1sCombo = handle ===
          "bambu-lab-p1s-combo-multi-material-multi-color-3d-printer",
        isA1Combo = /bambu-lab-a(?:1|2l)-(?:ams-)?combo-3d-printer/.test(handle),
        accessoryName = isA1Combo ? "AMS lite" : isP1sCombo ? "AMS" : "AMS 2 Pro",
        imageUrl = isA1Combo && scriptSource ? "https://cdn.shopify.com/s/files/1/1076/6490/0437/files/AMS-Lite-front.png?v=1791740593" : isP1sCombo
          ? "https://store.bblcdn.com/s5/default/06d91a5a2cbd409d851a120442f5b7e7.png"
          : scriptSource
            ? new URL("AMS-2-Pro.png", scriptSource).href
            : "/cdn/shop/t/2/assets/AMS-2-Pro.png",
        localePrefix = location.pathname.startsWith("/ar/") ? "/ar" : "",
        productUrl = localePrefix + "/products/" + (isA1Combo ? "bambu-lab-ams-lite" : isP1sCombo ? "bambu-lab-ams" : "bambu-lab-ams-2-pro"),
        card = media.querySelector(".m3d-h2d-included-overlay") || document.createElement("aside");
      card.className = "m3d-h2d-included-overlay m3d-template-included-overlay m3d-ams-badge";
      card.setAttribute("aria-label", `Included accessory: ${accessoryName}`);
      const alternateUrl = isA1Combo
        ? new URL("AMS-Lite.png", scriptSource).href
        : isP1sCombo ? imageUrl : "https://www.machines-3d.com/images/Image/Bambu-Lab-AMS-2-Pro-1.jpg";
      card.innerHTML = `<span class="m3d-ams-badge-visual ${isA1Combo ? 'is-lite' : 'is-enclosed'}"><img class="m3d-ams-badge-primary" src="${imageUrl}" alt="Bambu Lab ${accessoryName} included" loading="eager"><img class="m3d-ams-badge-alternate" src="${alternateUrl}" alt="Bambu Lab ${accessoryName} — alternate view" loading="eager"></span><span class="m3d-h2d-included-overlay__copy"><span class="m3d-h2d-included-overlay__label">${m3dProductLabel("included")}</span><span class="m3d-h2d-included-overlay__title">${accessoryName}</span><a class="m3d-h2d-included-overlay__link" href="${productUrl}">${m3dProductLabel("see_product")}</a></span>`;
      const alternate = card.querySelector('.m3d-ams-badge-alternate');
      const markReady = () => { if (alternate.naturalWidth > 0) card.classList.add('m3d-ams-alternate-ready'); };
      alternate.addEventListener('load', markReady, { once:true });
      markReady();
      card.style.cssText = '';
      media.append(card);
    },
    buildSpecs = (table) => {
      const section = document.createElement("section");
      ((section.className =
        "m3d-spec-preview m3d-desktop-specs m3d-template-specs"),
        section.setAttribute("aria-label", m3dProductLabel("technical_specs")));
      const heading = document.createElement("h2");
      heading.textContent = m3dProductLabel("technical_specs");
      const preview = document.createElement("div");
      preview.className = "m3d-spec-preview-table";
      const wrapperOuter = document.createElement("div"),
        wrapperInner = document.createElement("div"),
        previewTable = document.createElement("table"),
        body = document.createElement("tbody");
      wrapperOuter.className = "rte-table-wrapper";
      wrapperInner.className = "rte-table-wrapper";
      rowData(table).forEach(({ label, value }) => {
          const row = document.createElement("tr"),
            labelCell = document.createElement("td"),
            valueCell = document.createElement("td");
          labelCell.textContent = label;
          valueCell.textContent = short(value, 92);
          row.append(labelCell, valueCell);
          body.append(row);
        });
      previewTable.append(body);
      wrapperInner.append(previewTable);
      wrapperOuter.append(wrapperInner);
      preview.append(wrapperOuter);
      const details = document.createElement("details");
      return (
        (details.className = "m3d-spec-more"),
        (details.innerHTML =
          `<summary><span class="m3d-more-label">${m3dProductLabel("all_specs")}</span><span class="m3d-less-label">${m3dProductLabel("less")}</span><span class="m3d-spec-chevron">⌄</span></summary><div class="m3d-spec-full"></div>`),
        details.querySelector(".m3d-spec-full").append(table.cloneNode(!0)),
        section.append(heading, preview, details),
        section
      );
    },
    buildStory = (family, title) => {
      const wrapper = document.createElement("section");
      const mediaMarkup = (source, alt, { eager = false, poster = "" } = {}) =>
        /\.mp4(?:\?|$)/i.test(source)
          ? `<video muted autoplay loop playsinline preload="metadata"${poster ? ` poster="${poster}"` : ""} aria-label="${alt}"><source src="${source}" type="video/mp4"></video>`
          : `<img src="${source}" alt="${alt}" loading="${eager ? "eager" : "lazy"}">`;
      ((wrapper.className = "m3d-bambu-story"),
        family.immersive && wrapper.classList.add("m3d-bambu-story--immersive"),
        (wrapper.innerHTML = `<header class="m3d-bambu-story__intro"><span>${family.eyebrow || "Bambu Lab technology"}</span><h2>${family.headline || title}</h2><p>${family.intro || "A focused overview of the technologies that define this printer and its workflow."}</p></header>`),
        family.hero &&
          wrapper.insertAdjacentHTML(
            "beforeend",
            `<figure class="m3d-bambu-story__hero">${mediaMarkup(family.heroVideo || family.hero, family.headline || title, { eager: true, poster: family.hero })}</figure>${family.stats ? `<div class="m3d-bambu-story__stats">${family.stats.map(([value, label]) => `<div><strong>${value}</strong><span>${label}</span></div>`).join("")}</div>` : ""}`,
          ),
        family.sections.forEach(([heading, text, image, layout, poster], index) => {
          const article = document.createElement("article");
          ((article.className = `m3d-bambu-story__feature${index % 2 ? " is-reversed" : ""}${layout ? ` is-${layout}` : ""}`),
            (article.innerHTML = `<div class="m3d-bambu-story__media">${mediaMarkup(image, heading, { poster })}</div><div class="m3d-bambu-story__copy"><span>${family.eyebrow || "Bambu Lab technology"}</span><h3>${heading}</h3><p>${text}</p></div>`),
            wrapper.append(article));
        }));
      return wrapper;
    },
    enhanceImmersiveStory = (story) => {
      if (!story?.classList.contains("m3d-bambu-story--immersive")) return;
      const animated = [
        story.querySelector(".m3d-bambu-story__intro"),
        story.querySelector(".m3d-bambu-story__hero"),
        story.querySelector(".m3d-bambu-story__stats"),
        ...story.querySelectorAll(".m3d-bambu-story__feature"),
      ].filter(Boolean);
      const reduceMotion = matchMedia("(prefers-reduced-motion: reduce)").matches;
      if (reduceMotion || !("IntersectionObserver" in window)) {
        animated.forEach((element) => element.classList.add("is-visible"));
        return;
      }
      const observer = new IntersectionObserver(
        (entries) => entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add("is-visible");
          observer.unobserve(entry.target);
        }),
        { threshold: 0.14, rootMargin: "0px 0px -8%" },
      );
      animated.forEach((element) => observer.observe(element));
      story.querySelectorAll(".m3d-bambu-story__feature").forEach((feature) => {
        feature.addEventListener("pointermove", (event) => {
          const box = feature.getBoundingClientRect();
          feature.style.setProperty("--m3d-pointer-x", `${((event.clientX - box.left) / box.width - 0.5) * 10}px`);
          feature.style.setProperty("--m3d-pointer-y", `${((event.clientY - box.top) / box.height - 0.5) * 10}px`);
        });
        feature.addEventListener("pointerleave", () => {
          feature.style.setProperty("--m3d-pointer-x", "0px");
          feature.style.setProperty("--m3d-pointer-y", "0px");
        });
      });
      const videoObserver = new IntersectionObserver(
        (entries) => entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.play().catch(() => {});
          else entry.target.pause();
        }),
        { threshold: 0.3 },
      );
      story.querySelectorAll("video").forEach((video) => videoObserver.observe(video));
    },
    init = () => {
      const badgeHandle = location.pathname.split("/products/")[1]?.split(/[?#/]/)[0];
      const badgeMedia = document.querySelector(".product-information__media");
      if (badgeHandle && badgeMedia) addIncludedAms(badgeMedia, badgeHandle);
      if (document.querySelector('#MainContent')?.dataset.template?.startsWith('product.printer-')) return;
      if (!matchMedia("(min-width:750px)").matches) return;
      const handle = location.pathname
          .split("/products/")[1]
          ?.split(/[?#/]/)[0],
        familyKey = handles[handle];
      if (!familyKey) return;
      const main = document.querySelector(
          '#MainContent[data-template^="product"]',
        ),
        grid = main?.querySelector(".product-information__grid"),
        media = grid?.querySelector(".product-information__media"),
        details = grid?.querySelector(".product-details"),
        description =
          main?.querySelector(".m3d-desktop-description") ||
          details?.querySelector("rte-formatter.rte"),
        table = description?.querySelector("table"),
        title =
          clean(
            details?.querySelector('h1, .product-title, [class*="title"]')
              ?.textContent,
          ) || document.title.split("\u2013")[0].trim();
      if (main && media) addIncludedAms(media, handle);
      if (main?.querySelector("[data-m3d-server-story]")) main.classList.add("m3d-bambu-printer-template");
      if (document.documentElement.dataset.m3dBambuTemplate === handle) return;
      if (!main || !grid || !media || !details || !description || !table)
        return;
      ((document.documentElement.dataset.m3dBambuTemplate = handle),
        main.classList.add("m3d-bambu-printer-template"));
      let left = grid.querySelector(".m3d-desktop-media-column");
      (left ||
        ((left = document.createElement("div")),
        (left.className = "m3d-desktop-media-column"),
        media.before(left),
        left.append(media)),
        left.querySelector(".m3d-template-key-specs")?.remove());
      const rows = rowData(table);
      (left.append(buildFeatures(rows)),
        details.querySelector(".m3d-template-specs")?.remove());
      const specs = buildSpecs(table);
      details.append(specs);
      specs.style.setProperty("margin-top", "18px", "important");
      specs.style.setProperty("margin-bottom", "0", "important");
      const alignSpecsToMediaColumn = () => {
        /* The grid stretches the details column to the media/features column.
           Keep the specs flexible: calculating its height from its own bottom
           made the right column grow again after every refresh. */
        specs.style.removeProperty("flex");
        specs.style.removeProperty("height");
        specs.style.removeProperty("min-height");
        specs.style.removeProperty("max-height");
        /* Never remove specification rows from the preview. The fixed-height
           viewport and its white fade perform the visual truncation; keeping
           every row is also required for the complete dialog source. */
        specs
          .querySelectorAll(".m3d-spec-preview-table tbody tr")
          .forEach((row) => row.style.removeProperty("display"));
      };
      requestAnimationFrame(alignSpecsToMediaColumn);
      setTimeout(alignSpecsToMediaColumn, 600);
      const serverStory = main.querySelector("[data-m3d-server-story]");
      if (serverStory) { description.remove(); enhanceImmersiveStory(serverStory); return; }
      const story = buildStory(families[familyKey], title);
      (description.replaceChildren(story),
        description.classList.add("m3d-desktop-description"),
        grid.after(description),
        enhanceImmersiveStory(story));
    };
  (init(),
    document.addEventListener("DOMContentLoaded", init),
    document.addEventListener("shopify:section:load", init),
    setTimeout(init, 1200));

  const normalizeSpecsPopup = (root = document) => {
    root
      .querySelectorAll?.(".m3d-specs-popup .m3d-template-specs")
      .forEach((section) => {
        section.classList.remove("m3d-template-specs");
        section.removeAttribute("style");
        const productTitle = clean(
          document.querySelector(
            '#MainContent[data-template^="product"] .product-details h1, #MainContent[data-template^="product"] .product-title',
          )?.textContent,
        );
        const innerHeading = section.querySelector(":scope > h2");
        if (innerHeading && productTitle) innerHeading.textContent = productTitle;
        const disclosure = section.querySelector("details.m3d-spec-more");
        if (disclosure) disclosure.open = true;
        section.querySelectorAll(".m3d-spec-full tr").forEach((row) => {
          const cells = [...row.querySelectorAll(":scope > th, :scope > td")];
          if (cells.length !== 2) return;
          const blocks = (cell) =>
            [...cell.children]
              .map((node) => clean(node.textContent))
              .filter(Boolean);
          const labels = blocks(cells[0]);
          const values = blocks(cells[1]);
          if (values.length < 2 || labels.length < values.length) return;
          const headingCount = labels.length - values.length;
          if (headingCount > 1) return;
          const fragment = document.createDocumentFragment();
          if (headingCount === 1) {
            const headingRow = document.createElement("tr");
            const headingCell = document.createElement("td");
            headingRow.className = "m3d-spec-section-row";
            headingCell.className = "m3d-spec-label-cell";
            headingCell.colSpan = 2;
            headingCell.textContent = labels[0];
            headingRow.append(headingCell);
            fragment.append(headingRow);
          }
          values.forEach((value, index) => {
            const pairRow = document.createElement("tr");
            const labelCell = document.createElement("td");
            const valueCell = document.createElement("td");
            labelCell.className = "m3d-spec-label-cell";
            labelCell.textContent = labels[index + headingCount];
            valueCell.textContent = value;
            pairRow.append(labelCell, valueCell);
            fragment.append(pairRow);
          });
          row.replaceWith(fragment);
        });
        section
          .querySelectorAll(".m3d-spec-full tr")
          .forEach((row) => {
            const cells = [...row.querySelectorAll(":scope > th, :scope > td")];
            if (cells.length < 2) return;
            cells[0].classList.add("m3d-spec-label-cell");
            if (!clean(cells[1].textContent)) {
              row.classList.add("m3d-spec-section-row");
              cells[0].colSpan = cells.length;
              cells.slice(1).forEach((cell) => cell.remove());
            }
          });
        section
          .querySelectorAll(".m3d-spec-preview-table tr")
          .forEach((row) => row.style.removeProperty("display"));
      });
  };
  new MutationObserver((mutations) => {
    mutations.forEach((mutation) =>
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) normalizeSpecsPopup(node);
      }),
    );
  }).observe(document.body, { childList: true, subtree: true });
})();
(() => {
  const balance = () => {
    document.querySelectorAll(".m3d-template-key-specs").forEach((section) => {
      const cards = [...section.querySelectorAll(".m3d-key-spec")];
      if (cards.length !== 3) return;
      cards.forEach((card) =>
        card.classList.toggle(
          "is-dense",
          (card.querySelector(".m3d-key-spec-value")?.textContent || "").trim()
            .length > 110,
        ),
      );
      const weights = cards.map((card) => {
        const n = (
          card.querySelector(".m3d-key-spec-value")?.textContent || ""
        ).trim().length;
        return Math.max(0.72, Math.min(2.15, 0.72 + n / 70));
      });
      section.style.setProperty(
        "--m3d-feature-columns",
        weights.map((n) => "minmax(150px," + n.toFixed(2) + "fr)").join(" "),
      );
      requestAnimationFrame(() => {
        cards.forEach((card) => {
          const copy = card.querySelector(".m3d-key-spec-copy"),
            value = card.querySelector(".m3d-key-spec-value");
          if (!copy || !value) return;
          let size = card.classList.contains("is-dense") ? 8.5 : 10;
          card.style.setProperty("--m3d-feature-line-height", "1.1");
          card.style.setProperty("--m3d-feature-font-size", `${size}px`);
          while (
            (card.scrollHeight > card.clientHeight ||
              card.scrollWidth > card.clientWidth ||
              copy.scrollWidth > copy.clientWidth) &&
            size > 7
          ) {
            size -= 0.25;
            card.style.setProperty("--m3d-feature-font-size", `${size}px`);
          }
        });
      });
    });
  };
  balance();
  document.addEventListener("DOMContentLoaded", balance);
  document.addEventListener("shopify:section:load", balance);
  setTimeout(balance, 1400);
})();
(() => {
  const addComboFilamentNote = () => {
    if (document.querySelector('#MainContent')?.dataset.template?.startsWith('product.printer-')) return;
    const handle = location.pathname
      .split("/products/")[1]
      ?.split(/[?#/]/)[0];
    if (!handle?.includes("combo")) return;
    const media = document.querySelector(
      '#MainContent[data-template^="product"] .product-information__media',
    );
    if (!media || media.querySelector(".m3d-combo-filament-note")) return;
    const note = document.createElement("p");
    note.className = "m3d-combo-filament-note";
    note.textContent = m3dProductLabel("filament_note");
    media.append(note);
  };
  addComboFilamentNote();
  document.addEventListener("DOMContentLoaded", addComboFilamentNote);
  document.addEventListener("shopify:section:load", addComboFilamentNote);
  setTimeout(addComboFilamentNote, 900);
  setTimeout(addComboFilamentNote, 1800);
  setTimeout(addComboFilamentNote, 3000);
})();
//# sourceMappingURL=/cdn/shop/t/2/assets/m3d-bambu-printer-template.js.map?v=105753503396947044931788372216
